(() => {
  const language = (document.documentElement.lang || window.Shopify?.locale || 'en')
    .toLowerCase()
    .split('-')[0];

  const translations = {
    de: {
      progress: (amount) => `Nur noch ${amount} bis zum kostenlosen Versand`,
      label: 'Kostenloser Versand',
      complete: 'Glückwunsch! Der Versand ist kostenlos.'
    },
    nl: {
      progress: (amount) => `Nog ${amount} tot gratis verzending`,
      label: 'Gratis verzending',
      complete: 'Gefeliciteerd! Je bestelling wordt gratis verzonden.'
    },
    es: {
      progress: (amount) => `Te faltan ${amount} para conseguir el envío gratuito`,
      label: 'Envío gratuito',
      complete: '¡Enhorabuena! Tu pedido tiene envío gratuito.'
    },
    fr: {
      progress: (amount) => `Plus que ${amount} pour bénéficier de la livraison gratuite`,
      label: 'Livraison gratuite',
      complete: 'Félicitations ! La livraison est offerte.'
    },
    it: {
      progress: (amount) => `Ti mancano ${amount} per ottenere la spedizione gratuita`,
      label: 'Spedizione gratuita',
      complete: 'Complimenti! La spedizione è gratuita.'
    },
    pt: {
      progress: (amount) => `Faltam ${amount} para obter portes grátis`,
      label: 'Portes grátis',
      complete: 'Parabéns! A sua encomenda tem portes grátis.'
    },
    fi: {
      progress: (amount) => `Vielä ${amount} ilmaiseen toimitukseen`,
      label: 'Ilmainen toimitus',
      complete: 'Onnittelut! Tilauksesi toimitetaan ilmaiseksi.'
    },
    bg: {
      progress: (amount) => `Остават ви ${amount} до безплатна доставка`,
      label: 'Безплатна доставка',
      complete: 'Поздравления! Доставката е безплатна.'
    },
    et: {
      progress: (amount) => `Tasuta tarneni on jäänud ${amount}`,
      label: 'Tasuta tarne',
      complete: 'Palju õnne! Tarne on tasuta.'
    },
    hr: {
      progress: (amount) => `Još ${amount} do besplatne dostave`,
      label: 'Besplatna dostava',
      complete: 'Čestitamo! Dostava je besplatna.'
    },
    sl: {
      progress: (amount) => `Še ${amount} do brezplačne dostave`,
      label: 'Brezplačna dostava',
      complete: 'Čestitamo! Dostava je brezplačna.'
    },
    el: {
      progress: (amount) => `Μόνο ${amount} ακόμη για δωρεάν αποστολή`,
      label: 'Δωρεάν αποστολή',
      complete: 'Συγχαρητήρια! Η αποστολή είναι δωρεάν.'
    },
    lt: {
      progress: (amount) => `Iki nemokamo pristatymo trūksta ${amount}`,
      label: 'Nemokamas pristatymas',
      complete: 'Sveikiname! Pristatymas nemokamas.'
    },
    sk: {
      progress: (amount) => `Do dopravy zadarmo vám chýba ${amount}`,
      label: 'Doprava zadarmo',
      complete: 'Gratulujeme! Doprava je zadarmo.'
    },
    lv: {
      progress: (amount) => `Līdz bezmaksas piegādei trūkst ${amount}`,
      label: 'Bezmaksas piegāde',
      complete: 'Apsveicam! Piegāde ir bez maksas.'
    }
  };

  const copy = translations[language];
  if (!copy) return;

  const drawerSelector = '#aov-cart-drawer';
  const progressSelector = '.AOV-CartDrawer-RewardBar__Title';
  const labelSelector = '.AOV-CartDrawer-RewardBar__ProgressBar__GoalTitle';
  const progressPattern =
    /^(?:you are|you're)\s+(.+?)\s+away from(?:\s+getting)?\s+free shipping[.!]?$/i;
  const completePattern = /^congratulations!?\s+you(?:'|\u2019)ve reached all reward milestones!?$/i;

  const replaceText = (element, replacement) => {
    const raw = element.textContent || '';
    const trimmed = raw.trim();
    if (!trimmed || trimmed === replacement) return;
    element.textContent = raw.replace(trimmed, replacement);
  };

  const translateDrawer = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    drawer.querySelectorAll(progressSelector).forEach((element) => {
      const match = (element.textContent || '').trim().match(progressPattern);
      if (match) replaceText(element, copy.progress(match[1]));
      else if (completePattern.test((element.textContent || '').trim())) replaceText(element, copy.complete);
    });

    drawer.querySelectorAll(labelSelector).forEach((element) => {
      if (/^free shipping[.!]?$/i.test((element.textContent || '').trim())) {
        replaceText(element, copy.label);
      }
    });
  };

  const start = () => {
    translateDrawer();

    new MutationObserver(translateDrawer).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
